import { createSelector } from 'reselect'
import { ApplicationState } from 'store/types/common'

const getState = (state: ApplicationState) => state.organizerTournamentAndMembersAndIncome

export const makeGetOrganizerTournamentAndMembersAndIncome = createSelector(getState, state => state.OrganizerTournamentAndMembersAndIncome)
export const makeGetOrganizerTournamentAndMembersAndIncomeLoaded = createSelector(getState, state => state?.isLoaded)